import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { AuthService } from '../../../../core/auth.service';
import { LoadingService } from '../../../../core/loading.service';
import { DialogService } from '../../../../core/dialog.service';
import { AlertService } from '../../../../core/alert.service';
import { UtilityService } from '../../../../core/utility.service';
import { TranslatorService } from '../../../../core/translator.service';
import { OptionsSource } from '../../../../core/core.models';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { PromotionalCodeDocument, PromotionalCode } from '../promotional-code-documents.models';
import { UsersService } from '../../users/users.service'
import { User } from '../../users/users.models';

@Component({
  selector: 'app-promotional-code-documents-form',
  templateUrl: './promotional-code-documents-form.component.html',
  styleUrls: ['./promotional-code-documents-form.component.scss']
})
export class PromotionalCodeDocumentsFormComponent extends BaseFormComponent implements OnInit {
  public users: OptionsSource;
  public promotionalCodes: PromotionalCode[] = [];

  constructor(
    private usersService: UsersService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/promotional-code-documents`;
    this.prepareLookupData();
    this.prepareFormData(new PromotionalCodeDocument(), (response: PromotionalCodeDocument) => {
      response.breadcrumbsId = response.documentNumber;
      if(response.promotionalCodes) {
        this.promotionalCodes = response.promotionalCodes;
        for(let pc of this.promotionalCodes) {
          if(pc.promotionalCodeUser) {
            let user = <User>pc.promotionalCodeUser;
            pc.promotionalCodeUser = <string>user.id;
          }
        }
      }
      return response;
    });
  }

  prepareLookupData() {
    this.users = this.usersService.getUsersOptions();
  }

  public saveChanges(): void {
    
    if (!this.isFormValid())
        return;
        
    this.formData.promotionalCodes = this.promotionalCodes;

    if (this.id == null)
        this.baseService.create(this.url, this.formData, () => {
            this.onSaveSuccess();
        });
    else
        this.baseService.update(this.url, this.formData, () => {
            this.onSaveSuccess();
        });
  }

  public rowChanges(){
    this.pendingChanges = true;
  }
}
